import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            eng:'',
            kor:'',
            cn:'',
            display: 1,
            level: 0,
            category:0,
            files:[],
            deleteFiles:[],
            cardFile: [],
        }
    },
    validators: {
        eng: function (value) {
            return Validator.value(value)
                .required('주제명(영어)를 입력해주세요.')
        },
        kor:function (value) {
            return Validator.value(value)
                .required('주제명(한국어)를 입력해주세요.')
        },
        cn: function (value) {
            return Validator.value(value)
                .required('주제명(중국어)를 입력해주세요.')
        },
        display: function (value) {
            return Validator.value(value)
                .required('노출여부를 선택해주세요.')
        },
        level: function (value) {
            return Validator.value(value)
                .required('난이도를 선택해주세요.')
        },
        category :function (value) {
            return Validator.value(value)
        },
        files: function (value) {
            return Validator.value(value);
        },
        cardfile: function (value) {
            return Validator.value(value).custom(() => {
                if (value.length === 0) {
                    return "이미지를 선택해주세요.";
                }

            });
        },
    }
}
